/** Canonical project participant statuses from the backend. */
export const PROJECT_PARTICIPANT_STATUSES = [
  'pending',
  'screener_invited',
  'qualified',
  'invited',
  'disqualified',
  'completed',
];

export const PARTICIPANT_STATUS_BADGE_STYLES = {
  pending: { color: '#B7791F', background: '#FFF3DC' },
  screener_invited: { color: '#2B6CB0', background: '#EBF8FF' },
  qualified: { color: '#2C7A7B', background: '#E6FFFA' },
  invited: { color: '#B83280', background: '#FFECF1' },
  disqualified: { color: '#C53030', background: '#FED7D7' },
  completed: { color: '#33B273', background: '#F0FFF4' },
};

export const PARTICIPANT_STATUSES = {
  pending: { label: 'Pending', value: 'pending', variant: 'pending' },
  screener_invited: {
    label: 'Screener Invited',
    value: 'screener_invited',
    variant: 'screener_invited',
  },
  qualified: { label: 'Qualified', value: 'qualified', variant: 'qualified' },
  invited: { label: 'Invited', value: 'invited', variant: 'invited' },
  disqualified: {
    label: 'Disqualified',
    value: 'disqualified',
    variant: 'disqualified',
  },
  completed: { label: 'Completed', value: 'completed', variant: 'completed' },
};

export const PARTICIPANT_STATUS_FILTER_OPTIONS = PROJECT_PARTICIPANT_STATUSES.map(
  (value) => ({
    label: PARTICIPANT_STATUSES[value].label,
    value,
  }),
);

/** @deprecated `responded` is no longer a valid project participant status. */
export function normalizeParticipantStatusKey(status) {
  const key = String(status || '').toLowerCase();
  if (key === 'responded') return 'screener_invited';
  return key;
}

function normalizeParticipantStatusInput(status) {
  if (!status) return '';
  if (typeof status === 'object') {
    return status.value || status.label || '';
  }
  return status;
}

export function mapParticipantStatusMeta(status) {
  const key = normalizeParticipantStatusKey(
    normalizeParticipantStatusInput(status),
  );
  const meta = PARTICIPANT_STATUSES[key];
  const styles =
    PARTICIPANT_STATUS_BADGE_STYLES[key] ||
    PARTICIPANT_STATUS_BADGE_STYLES.pending;

  if (meta) {
    return {
      label: meta.label,
      value: meta.value,
      variant: meta.variant,
      color: styles.color,
      background: styles.background,
    };
  }

  if (!key) {
    return null;
  }

  return {
    label: key.charAt(0).toUpperCase() + key.slice(1),
    value: key,
    variant: 'pending',
    color: styles.color,
    background: styles.background,
  };
}

export function mapParticipantStatusBadge(status) {
  const meta = mapParticipantStatusMeta(status);
  if (!meta) return null;

  return {
    label: meta.label,
    color: meta.color,
    background: meta.background,
  };
}
